export default "/_next/static/images/fa603df2e3f2c881ea52c937f3081aee.svg";